<script setup lang="ts">
import { reactive, shallowRef, watch } from "vue";

import { provideListerContext } from "../composables/useCrudContext";
import type { ListerPageProps } from "../types";

const props = defineProps<{
  value: ListerPageProps;
}>();

// Create a reactive proxy to hold the context so we can update it
// when Inertia replaces the object during a navigation/filter.
const context = reactive({ ...props.value });

// Keep items as a shallow ref for real-time updates and performance
const items = shallowRef([...props.value.items]);

watch(() => props.value, (newVal) => {
  // Sync the reactive context when the parent prop object is replaced
  for (const key in context) {
    if (!(key in newVal)) {
      delete context[key as keyof typeof context];
    }
  }
  for (const key in newVal) {
    (context as any)[key] = newVal[key as keyof typeof newVal];
  }
}, { deep: false });

watch(() => props.value.items, (newItems) => {
  items.value = [...newItems];
});

provideListerContext(context as any, items);
</script>

<template>
  <slot />
</template>

